import React, { useState } from 'react'
import './AthleteCoach.css'
import '../layout/Spinner.css'

import { Modal, TransitionablePortal, Button } from 'semantic-ui-react'

const AthleteCoach = (props) => {

    const [displayActImage, setDisplayActImage] = useState(false)
    const [displaySatImage, setDisplaySatImage] = useState(false)
    const [displayTranscriptImage, setDisplayTranscriptImage] = useState(false)

    const athleteScores = props.athleteScores

    const animation = 'scale'
    const duration = 500

        const athleteCoach = props.athleteCoach
        var coachSpecialty = null
        var displayCoach = null

        var displaySat = null
        var displayAct = null
        var displayClassRank = null
        var displayGpa = null
        var displayIntendedMajor = null

        var highSchool = null
        var cityState = null
        var clubCoachName = null
        var clubCoachPhone = null
        var clubCoachEmail = null
        var highSchoolCoachName = null
        var highSchoolCoachPhone = null
        var highSchoolCoachEmail = null

        var hittingCoachPhone = null
        var hittingCoachEmail = null
        var pitchingCoachPhone = null
        var pitchingCoachEmail = null
        var catchingCoachPhone = null
        var catchingCoachEmail = null
        var specialtyCoachPhone = null
        var specialtyCoachEmail = null

        const athleteSat = props.athlete.sat
        const athleteAct = props.athlete.act
        const athleteRank = props.athlete.classRank
        
        const athleteGpa = props.athlete.gpa
        const athleteIntendedMajor = props.athlete.intendedMajor

        const phonePreFix = 'tel:'
        const emailPreFix = 'mailto:'

        const handleClick = (e) => {

            switch(e.target.id) {
                
                case 'actCheck':
                    setDisplayActImage(true)
                    break
                case 'satCheck':
                    setDisplaySatImage(true)
                    break
                case 'classRankCheck':
                    setDisplayTranscriptImage(true)
                    break
                default:
                    // default is transcriptCheck
                    setDisplayTranscriptImage(true)
            }
        }

        const handleActClose = () => {
            setDisplayActImage(false)
        }

        const handleSatClose = () => {
            setDisplaySatImage(false)
        }

        const handleTranscriptClose = () => {
            setDisplayTranscriptImage(false)
        }

        if (athleteAct > 0 && athleteScores.actScoreImage && athleteScores.actScoreImage !== '') {

            displayAct =
    
                <div className="AthleteDetailsScoreContainer">
                    <p>{athleteAct}</p>
                    <img src={require('../../images/checkBlue.svg').default} id='actCheck' onClick={handleClick} alt="Blue Check Mark"/>
                </div>

        } else {

            if (athleteAct > 0) {

                displayAct = <p>{athleteAct}</p>
                
            } else {
                displayAct = null
            }
        }

        if (athleteSat > 0 && athleteScores.satScoreImage && athleteScores.satScoreImage !== '') {

            displaySat =
    
                <div className="AthleteDetailsScoreContainer">
                    <p>{athleteSat}</p>
                    <img src={require('../../images/checkBlue.svg').default} id='satCheck' onClick={handleClick} alt="Blue Check Mark"/>
                </div>

        } else {

            if (athleteSat > 0) {

                displaySat = <p>{athleteSat}</p>
                
            } else {
                displaySat = null
            }
        }

        if (athleteRank !== 'None' && athleteRank !== '' && athleteScores.transcriptImage && athleteScores.transcriptImage !== '') {

            displayClassRank =
    
                <div className="AthleteDetailsScoreContainer">
                    <p>{athleteRank}</p>
                    <img src={require('../../images/checkBlue.svg').default} id='classRankCheck' onClick={handleClick} alt="Blue Check Mark"/>
                </div>

        } else {

            if (athleteRank !== 'None') {

                displayClassRank = <p>{athleteRank}</p>
                
            } else {
                displayClassRank = null
            }
        }

        if (athleteGpa > 0 && athleteScores.transcriptImage && athleteScores.transcriptImage !== '') {

            if (Number.isInteger(athleteGpa)) {
                // gpa does NOT have decimal

                displayGpa =
    
                <div className="AthleteDetailsScoreContainer">
                    <p>{athleteGpa.toFixed(1)}</p>
                    <img src={require('../../images/checkBlue.svg').default} id='transcriptCheck' onClick={handleClick} alt="Blue Check Mark"/>
                </div>

            } else {
                // gpa HAS decimal

                displayGpa =
    
                <div className="AthleteDetailsScoreContainer">
                    <p>{athleteGpa}</p>
                    <img src={require('../../images/checkBlue.svg').default} id='transcriptCheck' onClick={handleClick} alt="Blue Check Mark"/>
                </div>
            }

        } else {

            if (athleteGpa > 0) {

                if (Number.isInteger(athleteGpa)) {
                    // gpa does NOT have decimal
                    displayGpa = <p>{athleteGpa.toFixed(1)}</p>
                  } else {
                    // gpa HAS decimal
                    displayGpa = <p>{athleteGpa}</p>
                  }
            } else {
                displayGpa = null
            }
        }

        if (athleteIntendedMajor !== 'None') {
            displayIntendedMajor = athleteIntendedMajor
        }

        if (props.athlete.highSchoolName !== 'None') {
            highSchool = <p>{props.athlete.highSchoolName}</p>
        }

        if (props.athlete.highSchoolCityState !== 'None') {
            cityState = <p>{props.athlete.highSchoolCityState}</p>
        }

        if (athleteCoach) {

            function formatPhoneNumber(phoneNumberString) {
                var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
                var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
                if (match) {
                  return '(' + match[1] + ') ' + match[2] + '-' + match[3]
                }
                return null
            }

            if (athleteCoach.clubCoachPhone !== '') {

                clubCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.clubCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.clubCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.clubCoachEmail !== '') {

                clubCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.clubCoachEmail}>
                                <p>{athleteCoach.clubCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.clubCoachName !== '') {
                clubCoachName = 
                
                <div className="AthleteDetailsClubCoachContainer">
                    <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>Club Coach: </p>
                        </div>
                        <p>{athleteCoach.clubCoachName}</p>
                    </div>
                    {clubCoachEmail}
                    {clubCoachPhone}
                </div>
                
            }

            if (athleteCoach.highSchoolCoachPhone !== '') {

                highSchoolCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.highSchoolCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.highSchoolCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.highSchoolCoachEmail !== '') {

                highSchoolCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.highSchoolCoachEmail}>
                                <p>{athleteCoach.highSchoolCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.highSchoolCoachName !== '') {
                highSchoolCoachName = 
                
                <div className="AthleteDetailsHighSchoolCoachContainer">
                    <div className="AthleteDetailsCoachContainerRow">
                    <div className="AthleteDetailsCoachContainerRowTitle">
                        <p>H.S. Coach: </p>
                    </div>
                    <p>{athleteCoach.highSchoolCoachName}</p>
                    </div>
                    {highSchoolCoachPhone}
                    {highSchoolCoachEmail}
                </div> 
            }

            if (athleteCoach.hittingCoachPhone && athleteCoach.hittingCoachPhone !== '') {

                hittingCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.hittingCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.hittingCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.hittingCoachEmail && athleteCoach.hittingCoachEmail !== '') {

                hittingCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.hittingCoachEmail}>
                                <p>{athleteCoach.hittingCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.hittingCoachName && athleteCoach.hittingCoachName !== '') {

                coachSpecialty = [
                    <div className="AthleteDetailsSpecialtyCoachContainerSection" key='hittingCoachName'>
                        <div className="AthleteDetailsCoachContainerRow">
                            <div className="AthleteDetailsCoachContainerRowTitle">
                                <p>Hitting Coach: </p>
                            </div>
                            <p>{athleteCoach.hittingCoachName}</p>
                        </div>
                        {hittingCoachPhone}
                        {hittingCoachEmail}
                    </div>
                ]   
            }

            if (athleteCoach.pitchingCoachPhone && athleteCoach.pitchingCoachPhone !== '') {

                pitchingCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.pitchingCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.pitchingCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.pitchingCoachEmail && athleteCoach.pitchingCoachEmail !== '') {

                pitchingCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.pitchingCoachEmail}>
                                <p>{athleteCoach.pitchingCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.pitchingCoachName && athleteCoach.pitchingCoachName !== '') {

                coachSpecialty = [
                    coachSpecialty,
                    <div className="AthleteDetailsSpecialtyCoachContainerSection" key='pitchingCoachSection'>
                        <div className="AthleteDetailsCoachContainerRow">
                            <div className="AthleteDetailsCoachContainerRowTitle">
                                <p>Pitching Coach: </p>
                            </div>
                            <p>{athleteCoach.pitchingCoachName}</p>
                        </div>
                        {pitchingCoachPhone}
                        {pitchingCoachEmail}
                    </div>
                ]
            }

            if (athleteCoach.catchingCoachPhone && athleteCoach.catchingCoachPhone !== '') {

                catchingCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.catchingCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.catchingCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.catchingCoachEmail && athleteCoach.catchingCoachEmail !== '') {

                catchingCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.catchingCoachEmail}>
                                <p>{athleteCoach.catchingCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.catchingCoachName && athleteCoach.catchingCoachName !== '') {

                coachSpecialty = [
                    coachSpecialty,
                    <div className="AthleteDetailsSpecialtyCoachContainerSection" key='catchingCoachSection'>
                        <div className="AthleteDetailsCoachContainerRow">
                            <div className="AthleteDetailsCoachContainerRowTitle">
                                <p>Catching Coach: </p>
                            </div>
                            <p>{athleteCoach.catchingCoachName}</p>
                        </div>
                        {catchingCoachPhone}
                        {catchingCoachEmail}
                    </div>
                ]
            }

            if (athleteCoach.specialtyCoachPhone && athleteCoach.specialtyCoachPhone !== '') {

                specialtyCoachPhone = 

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>C: </p>
                        </div>
                        <div className="AthleteDetailsPhoneContainer">
                            <a href={phonePreFix+formatPhoneNumber(athleteCoach.specialtyCoachPhone)}>
                                <p>{formatPhoneNumber(athleteCoach.specialtyCoachPhone)}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.specialtyCoachEmail && athleteCoach.specialtyCoachEmail !== '') {

                specialtyCoachEmail =

                <div className="AthleteDetailsCoachContainerRow">
                        <div className="AthleteDetailsCoachContainerRowTitle">
                            <p>E: </p>
                        </div>
                        <div className="AthleteDetailsEmailContainer">
                            <a href={emailPreFix+athleteCoach.specialtyCoachEmail}>
                                <p>{athleteCoach.specialtyCoachEmail}</p>
                            </a>
                        </div>
                    </div>
            }

            if (athleteCoach.specialtyCoachName && athleteCoach.specialtyCoachName !== '' &&
            athleteCoach.specialtyCoachFocus && athleteCoach.specialtyCoachFocus !== '') {

                coachSpecialty = [
                    coachSpecialty,
                    <div className="AthleteDetailsSpecialtyCoachContainerSection" key='specialtyCoachSection'>
                        <div className="AthleteDetailsCoachContainerRow">
                            <div className="AthleteDetailsCoachContainerRowTitle">
                                <p>{athleteCoach.specialtyCoachFocus} Coach: </p>
                            </div>
                            <p>{athleteCoach.specialtyCoachName}</p>
                        </div>
                        {specialtyCoachPhone}
                        {specialtyCoachEmail}
                    </div>
                ]
            }

            displayCoach = (

                <div className="AthleteCoachContainer">
                    <div className="AthleteCoachAcademicsInfoContainer">
                        <div className="AthleteDetailsCoachContainer">
                            <div className="AthleteDetailsCoachContainerTitle">
                                <h3>Academic Information</h3>
                            </div>
                            <div className="AthleteDetailsAcademicGradesContainer">
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>GPA: </p>
                                    </div>
                                    {displayGpa}
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>ACT: </p>
                                    </div>
                                    {displayAct}
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>SAT: </p>
                                    </div>
                                    {displaySat}
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>Class Rank: </p>
                                    </div>
                                    {displayClassRank}
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>Major: </p>
                                    </div>
                                    <p>{displayIntendedMajor}</p>
                                </div>
                            </div>
                            <div className="AthleteDetailsAcademicSchoolContainer">
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>High School: </p>
                                    </div>
                                    {highSchool}
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                    <div className="AthleteDetailsCoachContainerRowTitle">
                                        <p>City, State: </p>
                                    </div>
                                    {cityState}
                                </div>
                            </div>
                        </div>
                        <div className="AthleteDetailsCoachContainer">
                            <div className="AthleteDetailsCoachContainerTitle">
                                <h3>Coaching Information</h3>
                            </div>
                            <div className="AthleteDetailsClubCoachContainer">
                                <div className="AthleteDetailsCoachContainerRow">
                                <div className="AthleteDetailsCoachContainerRowTitle">
                                    <p>Club: </p>
                                </div>
                                <p>{props.athlete.clubName}</p>
                                </div>
                                <div className="AthleteDetailsCoachContainerRow">
                                <div className="AthleteDetailsCoachContainerRowTitle">
                                    <p>Team: </p>
                                </div>
                                <p>{props.athlete.clubTeamName}</p>
                                </div>
                                {clubCoachName}
                            </div>
                            {highSchoolCoachName}
                            <div className="AthleteDetailsSpecialtyCoachContainer">
                                {coachSpecialty}
                            </div>
                        </div>
                        <TransitionablePortal
                        transition={{animation, duration}}
                        open={displayActImage}
                        onClose={handleActClose}
                        >
                            <Modal
                            onClose={handleActClose}
                            open={true}
                            >
                                <Modal.Content scrolling>
                                    <div className="AdminTopButtonsProgressContainer">
                                        <div className="AdminTopButtonsContainer">
                                            <Button
                                                floated='left'
                                                circular
                                                icon='close'
                                                onClick={handleActClose}
                                            />
                                        </div>
                                    </div>
                                    <div className="ScoreImageContainer">
                                        <img src={athleteScores.actScoreImage} alt="Athlete ACT"/>
                                    </div>
                                </Modal.Content>
                            </Modal>
                        </TransitionablePortal>
                        <TransitionablePortal
                        transition={{animation, duration}}
                        open={displaySatImage}
                        onClose={handleSatClose}
                        >
                            <Modal
                            onClose={handleSatClose}
                            open={true}
                            >
                                <Modal.Content scrolling>
                                    <div className="AdminTopButtonsProgressContainer">
                                        <div className="AdminTopButtonsContainer">
                                            <Button
                                                floated='left'
                                                circular
                                                icon='close'
                                                onClick={handleSatClose}
                                            />
                                        </div>
                                    </div>
                                    <div className="ScoreImageContainer">
                                        <img src={athleteScores.satScoreImage} alt="Athlete SAT"/>
                                    </div>
                                </Modal.Content>
                            </Modal>
                        </TransitionablePortal>
                        <TransitionablePortal
                        transition={{animation, duration}}
                        open={displayTranscriptImage}
                        onClose={handleTranscriptClose}
                        >
                            <Modal
                            onClose={handleTranscriptClose}
                            open={true}
                            >
                                <Modal.Content scrolling>
                                    <div className="AdminTopButtonsProgressContainer">
                                        <div className="AdminTopButtonsContainer">
                                            <Button
                                                floated='left'
                                                circular
                                                icon='close'
                                                onClick={handleTranscriptClose}
                                            />
                                        </div>
                                    </div>
                                    <div className="ScoreImageContainer">
                                        <img src={athleteScores.transcriptImage} alt="Athlete Transcript"/>
                                    </div>
                                </Modal.Content>
                            </Modal>
                        </TransitionablePortal>
                    </div>
                </div>
            )
        }
        return displayCoach
}

export default AthleteCoach